import axios from 'axios';

const getValorMoeda = moeda => axios.get(`/valores-moedas/${moeda}`);

const getTaxaVendaMoeda = moeda => axios.get(`/valores-moedas/${moeda}/taxa-venda`);

export default {
  getValorMoeda,
  getTaxaVendaMoeda,
};
